import {FC, useEffect} from 'react'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {useLayout} from '../core'
import {DrawerComponent} from '../../assets/ts/components'
import {WithChildren} from '../../helpers'
import CreateProject from "../../../app/pages/project/create-project/CreateProject";
import AddHours from '../../../app/modules/accounts/components/hours/AddHours';
import ContactUs from './ContactUs'

const Content: FC<WithChildren> = ({children}) => {
  const {classes} = useLayout()
  const location = useLocation()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  return (
    <div id='kt_content_container' className={clsx(classes.contentContainer.join(' '))}>
      {children}
      <CreateProject />
      <AddHours />
      <ContactUs/>
    </div>
  )
}

export {Content}
